import { createApiCall } from 'lib/base';

const PATCH_EDIT_BANK = 'PATCH_EDIT_BANK';

export const editBankApi = createApiCall<{ id: string; payload: any }>(
  PATCH_EDIT_BANK,
  ({ id, payload }) => ({
    endpoint: `api/admin/banks/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editBankApi;
